
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllTaskLogList } from '../service/taskLog.service';

// Initial state definition
const initialState = {
    taskLogs: [],
    isLoading: false,
    error: null,
    pagination: {
        page: 0,
        limit: 10,
        totalCount: 0,
        isNext: false,
    },
    filters: {
        start: null,
        end: null,
    },
    workSpaceId: null,
    search: ""
};

// Async thunk to fetch candidates
export const getAllTaskLog = createAsyncThunk(
    'taskLogSlice/list',
    async ({ skip, limit = 10, filter = {}, search = '', workspaceId } = {}) => {

        const response = await getAllTaskLogList(skip, limit, filter, search, workspaceId);
        return response?.data;
    }
);


// Slice definition
export const taskLogSlice = createSlice({
    name: 'taskLogSlice',
    initialState,
    reducers: {
        setPaginationPage: (state, action) => {
            const { page, limit } = action.payload
            state.pagination.page = page
            state.pagination.limit = limit
        },
        setFilters: (state, action) => {
            state.filters = action.payload
        },
        setsearch: (state, action) => {
            state.search = action.payload
        },
        setWorkSpaceId: (state, action) => {
            state.workSpaceId = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllTaskLog.pending, (state) => {
                state.isLoading = true;
            })

            .addCase(getAllTaskLog.fulfilled, (state, action) => {
                state.taskLogs = action.payload.data;
                state.isLoading = false;
                state.error = null;
                state.pagination.totalCount = action.payload.totalCount
                state.pagination.isNext = action.payload.isNext
            })
            .addCase(getAllTaskLog.rejected, (state, action) => {
                state.taskLogs = [];
                state.isLoading = false;
                state.error = action.payload.error;
            })
    },
});

export default taskLogSlice.reducer;

// Export actions (if any)
export const {
    setPaginationPage,
    setFilters,
    setsearch,
    setWorkSpaceId
} = taskLogSlice.actions;
